var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.file)?_c('div',{staticClass:"vue-image-previewer"},[_c('img',{staticClass:"vue-image-previewer__image",attrs:{"src":_vm.file_,"alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }